/*global translate*/

import React, { Component, useState } from 'react'
import { connect } from 'react-redux'
import { VariableSizeList } from 'react-window';

const { rxaget, stringToColour, rxChangeSlug, subString ,changeColorSVG} = global.rootRequire('classes/ulti')
const { checkNameContact, checkNameUser, changeColorAva } = global.rootRequire('classes/chat')
const { rxgetLocal } = global.rootRequire('classes/request')

const ListMemberRow = global.rootRequire('components/shares/calendar/AddMemberRows').default
const rxio = global.rootRequire('classes/socket').default
const chatDB = global.rootRequire('classes/indexedDB').default
const worker = global.rootRequire('classes/globalUser')

global.isclient && require('./../rxPopup.css')
global.isclient && require('./AddMember.css')


let timeout = null
function SearchUserName({ value = "", onChange, theme }) {
  const [text, setText] = useState(value)

  function updateSearch(event) {
    setText(event.target.value)
    try {
      let strText = event.target.value
      if (timeout) {  
        clearTimeout(timeout)
      }
      if(strText.length === 0){
        onChange(strText) 
      }else{
        timeout = setTimeout(function() {
          if (typeof onChange === 'function' && strText) {
            onChange(strText)
          }
        }, 500);
      }
    } catch(e) {}
  }

  return (
    <div className='popup_choose_leader_search_area'>
      <div className='popup_choose_leader_icon_search_area'>
        <img className='popup_choose_leader_icon_search filter_img_class' src={changeColorSVG('./images/default/icons/search-active.svg')} alt='' />
      </div>
      <input type='search' maxLength='30' id='newgroup_search_input' placeholder={translate("Search")} onChange={updateSearch} value={text} autoComplete='off'
        className={theme === 'darkTheme' ? 'popup_choose_leader_search_input darkThemeInput' : 'popup_choose_leader_search_input lightThemeInput'}>
      </input>
    </div>

  )
}

class RxAddMember extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      user: {},
      group: {},
      groupsNChat: [],
      groupsNChatOrigin: [],
      groupsNChatChecked: [],
      groupsNChatCheckedUser: rxaget(props, 'arrRecipients', []),
      nameNewGroup: '',
      heightListMember: 0,
      pagingSearch: 0
    }

    if (this.state.groupsNChatCheckedUser && this.state.groupsNChatCheckedUser.constructor === Array && this.state.groupsNChatCheckedUser.length > 0) {
      this.state.groupsNChatChecked = this.state.groupsNChatCheckedUser.map(g => g.phone || g.username)
    }

    this.compareContact = this.compareContact.bind(this)
    this.handleScrollList = this.handleScrollList.bind(this)

    this.createNewChat = this.createNewChat.bind(this)

    this.token = rxaget(this.props, 'netaauth.user.token', '')
    this.userid = rxaget(this.props, 'netaauth.user.id', '')
    
    this.blockScroll = false
  }


  componentDidMount() {
    this.getInitList()
  }

  getInitList() {
    chatDB.contacts.limit(40).toArray().then(arrUsers => {

      let userid = rxaget(this.props, 'netaauth.user.id', '')
      let arrUsername = arrUsers.map(u => u.phone)
      chatDB.users.filter((user) => { return (arrUsername.indexOf(user.phone) !== -1 ) })
        .limit(40)
        .toArray()
        .then((result) => {
          if (result && result.constructor === Array) {
            let arrSort = this.sortByVietnameseAlphabet(result)
            this.setState({
              groupsNChat: result,
              groupsNChatOrigin: result
            })
          }
        })
    })
  }

  sortByVietnameseAlphabet(arr) {
    const vietnameseAlphabet = ["a", "ă", "â", "b", "c", "d", "đ", "e", "ê", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "ô", "ơ", "p", "q", "r", "s", "t", "u", "ư", "v", "w", "x", "y", "z"];

    let compareVietnameseStrings = (a, b) => {
      let name_display_a = (a.full_name) ? a.full_name : (a.phone) ? a.phone : ''
      let name_character_a = name_display_a.charAt(0)

      let name_display_b = (b.full_name) ? b.full_name : (b.phone) ? b.phone : ''
      let name_character_b = name_display_b.charAt(0)

      let indexA = vietnameseAlphabet.indexOf(name_character_a.toLowerCase())
      let indexB = vietnameseAlphabet.indexOf(name_character_b.toLowerCase())
      if (indexA === -1) indexA = 9999
      if (indexB === -1) indexB = 9999
      return indexA - indexB
    }
  
    return arr.sort(compareVietnameseStrings)
  }

  onClickClosePopup() {
    this.props.onClickCloseAddMember()
  }

  compareContact(a, b) {
    let userA = rxChangeSlug(checkNameUser(a, this.userid, this.props.netaauth))
    let userB = rxChangeSlug(checkNameUser(b, this.userid, this.props.netaauth))

    if (userA < userB) {
      return -1;
    }
    if (userA > userB) {
      return 1;
    }
    return 0;
  }

  handleScrollList(event) {
    if (event && event.scrollDirection === 'forward' && (this.state.heightListMember - 300) > 0 && event.scrollOffset > (this.state.heightListMember - 300)) {
      if (!this.blockScroll && this.state.searchNchatValue !== '') {
        this.blockScroll = true

        let pagingSearch = this.state.pagingSearch + 1
      
        this.onCallAPISearch(this.state.searchNchatValue, pagingSearch)  
      }
    }
  }

  onCallAPISearch(value, paging) {
    let pagingSearch = 0
    let pageLimit = 20
    if (value === this.state.searchNchatValue && paging > 0) {
      pagingSearch = paging
    } else if (value !== this.state.searchNchatValue) {
      this.setState({
        groupsNChat: [],
        groupsNChatOrigin: [],
        searchNchatValue: value,
        pagingSearch: 0,
        heightListMember: 0
      })
    }

    let tokenStr = this.token

    const api_search = global.rxu.config.get_search
    fetch(api_search + '?type=1&keywords='+encodeURIComponent(value)+'&offset='+pagingSearch*pageLimit+'&limit='+pageLimit, {
      method: 'GET',
      headers: { Accept: 'application/json', 'TC-Token': tokenStr, Connection: 'Keep-Alive', 'Accept-Encoding': 'gzip' } 
    })
    .then(res => res.json())
    .then((json) => {
      try {
        if (json) {
              let result = json
              if (paging) {
                let groupsNChatOrigin = this.state.groupsNChat
                groupsNChatOrigin = groupsNChatOrigin.filter(uGrp => uGrp.id !== -1)
                result = [...groupsNChatOrigin, ...json]
              }

              let arrGroupsTmp = result
              let arrContact = []

              arrGroupsTmp = arrGroupsTmp.filter((value, index, self) =>
                index === self.findIndex((t) => (
                  t.Id === value.Id
                ))
              )

              let heightListMember = 0
              for (let i in arrGroupsTmp) {
                let uCurrent = arrGroupsTmp[i]
                uCurrent.id = uCurrent.Id
                let uPrev = (i > 0) ? arrGroupsTmp[i-1] : {}

                if (uCurrent.id.toString() !== this.userid.toString()) {
                  let contactTitle = ''
                  let eleContactTitle = rxChangeSlug(checkNameUser(uCurrent, this.userid, this.props.netaauth)).slice(0, 1)
                  let elePreContactTitle = rxChangeSlug(checkNameUser(uPrev, this.userid, this.props.netaauth)).slice(0, 1)

                  
                  heightListMember += 60
                  arrContact.push(uCurrent)
                }
              }

              this.setState({
                groupsNChat: arrContact,
                groupsNChatOrigin: arrContact,
                searchNchatValue: value,
                pagingSearch: pagingSearch,
                heightListMember: heightListMember
              }, () => {
                setTimeout(() => {
                  this.blockScroll = false
                }, 500)
              })
        } else {
          this.blockScroll = false
        }
      } catch(e) {
        console.log(e)
        this.blockScroll = false
      }
    })
    .catch(er => { console.log('can\'t search users'); this.blockScroll = false; return er })
  }

  onChangeSearchNChat(value) {
    if (value && value.trim()) {
      this.onCallAPISearch(value)
    } else {
      this.getInitList()
    }
  }


  resetState() {
    this.setState({
      user: {},
      groupsNChat: [],
      groupsNChatOrigin: [],
      groupsNChatChecked: [],
      groupsNChatCheckedUser: [],
      nameNewGroup: ''
    }, () => {
      try {
        this.props.closePopup()
      } catch (e) { }
    })
  }

  createNewChat(user) {
    if (user.username) {
      user.phone = user.username
    } else {
      user.username = user.phone
    }

    let groupsNChatChecked = this.state.groupsNChatChecked
    let groupsNChatCheckedUser = this.state.groupsNChatCheckedUser

    // groupsNChatChecked = [user.id]
    // groupsNChatCheckedUser = [user]

    if (groupsNChatChecked.indexOf(user.username) === -1) {
      groupsNChatChecked.push(user.username)
      groupsNChatCheckedUser.push(user)
    } else {
      const findIndex = groupsNChatCheckedUser.findIndex(u => u.username === user.username)
      const findIndexChecked = groupsNChatChecked.indexOf(user.username)

      if (findIndex !== -1) {
        groupsNChatCheckedUser.splice(findIndex , 1)
      }

      if (findIndexChecked !== -1) {
        groupsNChatChecked.splice(findIndexChecked, 1)
      }
      
    }

    this.setState({ groupsNChatChecked, groupsNChatCheckedUser })
  }

  onClickSaveMember() {
    let groupsNChatCheckedUser = this.state.groupsNChatCheckedUser

    this.props.onClickSaveMember(groupsNChatCheckedUser)
  }


  render() {
    return (
      <div>
        <div className='zchat_popupscreen'>
          <div className='zchat_popupscreen_bg'></div>
          <div className='zchat_popupscreen_main'>
            <div className='zchat_popupcenter'>
              <div className='calendar-addmember-box'>
                <div className='popup_choose_leader_title_area'>
                  <div className='popup_choose_leader_title'>
                    {translate('Add participants')}
                  </div>
          

                  <div className="calendar-addmember_btn_left" onClick={e => this.props.onClickCloseAddMember()}>
                    <img className="btn-back-calendar" alt="" src="./images/default/icons/icon-back.svg" />
                  </div>
                  <div className="calendar-addmember_btn_right" onClick={e => this.onClickSaveMember()}>
                    <span className="btn_save_calendar">{translate('Done')}</span>
                  </div>

                </div>

                <SearchUserName theme={rxaget(this.props, "themeBackgroudValue")} onChange={(value) => {this.onChangeSearchNChat(value)}}/>

                <div className='calendar-addmember-list'>
                  {(this.state.groupsNChatCheckedUser.length > 0) &&
                    <div className='new_list_contacts_selected'>
                      { this.state.groupsNChatCheckedUser.map((ele, index) => (
                        <div key={ele.id} className='item-row-selected-user'>
                          {subString(checkNameUser(ele), 20)}
                          <img className='item-row-selected-close' src={changeColorSVG('./images/default/icons/icon-close.png')} alt='' onClick={e => { this.createNewChat(ele) }} />
                        </div>))
                      }
                    </div>
                  }

                  <ListMemberRow
                    height={430}
                    width={400}
                    items={this.state.groupsNChat}
                    toggleItemActive={this.createNewChat}
                    groupsNChatChecked={this.state.groupsNChatChecked}
                    typePopup={''}
                    flagCreateGroupPopup={true}
                    handleScrollList={this.handleScrollList}
                  />
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  netaPopup: state.netaPopup,
  netaauth: state.netaauth,
  user: state.user,
  themeBackgroudValue: state.themeBackgroudValue
})

const mapDispatchToProps = {}

const ComponentAddMember = connect(
  mapStateToProps,
  mapDispatchToProps
)(RxAddMember)

export default ComponentAddMember
